import { Link, NavLink } from 'react-router-dom'
import Logo from '../Logo'
import AuthHeader from '../AuthHeader'

const NAV = [
  { to: '/shor', label: 'Leaderboard', end: true },
  { to: '/shor/explorer', label: 'Compiler Explorer', end: false },
  { to: '/shor/learn', label: 'Learn', end: false },
  { to: '/resource-verification', label: 'Lean deep dive', end: false },
]

/** Sticky header shared by the FormalRV Shor pages. */
export default function FormalRVHeader({ crumb }: { crumb?: string }) {
  return (
    <header className="bg-white/85 backdrop-blur border-b border-qcloud-border px-4 sm:px-6 py-3 flex items-center justify-between gap-3 sticky top-0 z-20">
      <div className="flex items-center gap-3 min-w-0">
        <Link to="/" className="flex items-center gap-2 hover:opacity-80 shrink-0">
          <Logo size="small" />
          <span className="hidden sm:inline text-xl font-bold bg-gradient-to-r from-qcloud-primary to-qcloud-secondary bg-clip-text text-transparent">
            QuantumArena
          </span>
        </Link>
        <span className="text-qcloud-border">·</span>
        <Link to="/shor" className="text-sm font-semibold text-qcloud-text hover:text-qcloud-primary truncate">FT Shor Leaderboard</Link>
        {crumb && (
          <span className="hidden sm:contents">
            <span className="text-qcloud-border">/</span>
            <span className="text-sm text-qcloud-muted truncate">{crumb}</span>
          </span>
        )}
      </div>
      <nav className="flex items-center gap-4 shrink-0">
        {NAV.map(n => (
          <NavLink
            key={n.to}
            to={n.to}
            end={n.end}
            className={({ isActive }) =>
              `hidden md:inline text-sm transition-colors ${isActive ? 'font-semibold text-qcloud-primary' : 'text-qcloud-muted hover:text-qcloud-primary'}`}
          >
            {n.label}
          </NavLink>
        ))}
        <AuthHeader />
      </nav>
    </header>
  )
}
